import Layout from '@/layout/index.vue';

export default [
  {
    path: '/poManage',
    component: Layout,
    name: 'poManage',
    redirect: '/poManage/poList',
    meta: { title: 'PO工单', icon: 'el-icon-s-management' },
    children: [
      {
        path: 'poList',
        name: 'poList',
        component: () => import('@/views/appManage/layout.vue'),
        meta: { title: 'PO工单', icon: 'el-icon-menu' },
      },
    ],
  },
];
